import { isEmpty } from 'lodash-es'

import { EMPTY_LIST } from '../../../constants/common'
import { LOCAL_STORAGE_MAILS_ACTIVE_ACCOUNT_KEY } from '../../../constants/storage'
import i18n from '../../../i18n'
import { getEmailAvailableAccounts } from '../../../utils/email'
import {
  getStorageSerializedItem,
  removeStorageItem,
} from '../../../utils/storage'
import { EmailSubMenuParam } from '../Email.enums'
import { isEmailCorporate, isEmailShared } from '../Email.utils'

import {
  ACCOUNTS_CORPORATE,
  ACCOUNTS_PRIVATE,
  ACCOUNTS_SHARED,
  FOLDER_ITEM_KEYS,
  ITEM_KEYS,
  NEED_RECONNECT,
  SECTION_GROUP_TITLE,
} from './EmailSubMenu.constants'

function getEmailSubMenuSection(type, selected, accounts, filter) {
  if (isEmpty(accounts) || accounts[type].length === 0) {
    return {}
  }

  const items = getEmailAvailableAccounts(accounts[type]).filter(item =>
    filter
      ? item[ITEM_KEYS.titleKey].toLowerCase().includes(filter.toLowerCase())
      : true
  )

  if (items.length === 0) {
    return {}
  }

  const count = items.reduce((acc, curr) => acc + curr[ITEM_KEYS.countKey], 0)

  return {
    accordionTitle: i18n.t(SECTION_GROUP_TITLE[type]),
    count,
    initOpen: !!items.find(
      i => i[ITEM_KEYS.selectedKey] === selected?.[ITEM_KEYS.selectedKey]
    ),
    items: [...items],
    qaName: type,
  }
}

export function isSubMenuEmailNeedReconnect(item) {
  return item[NEED_RECONNECT]
}

export function getSubMenuEmailsSectionList(selected, accounts, search) {
  return [
    { ...getEmailSubMenuSection(ACCOUNTS_PRIVATE, selected, accounts, search) },
    {
      ...getEmailSubMenuSection(ACCOUNTS_CORPORATE, selected, accounts, search),
    },
    { ...getEmailSubMenuSection(ACCOUNTS_SHARED, selected, accounts, search) },
  ].filter(value => !isEmpty(value))
}

export function getSubMenuEmailsAccountsList(accounts) {
  if (isEmpty(accounts)) {
    return EMPTY_LIST
  }

  return getEmailAvailableAccounts([
    ...accounts[ACCOUNTS_PRIVATE],
    ...accounts[ACCOUNTS_CORPORATE],
    ...accounts[ACCOUNTS_SHARED],
  ])
}

export function getSubMenuEmailsDefaultValue(accounts) {
  const prevActiveAccountId = getStorageSerializedItem(
    LOCAL_STORAGE_MAILS_ACTIVE_ACCOUNT_KEY
  )
  const prevAccount = accounts.find(
    i => i[ITEM_KEYS.selectedKey] === prevActiveAccountId
  )

  if (prevActiveAccountId && prevAccount) {
    return prevAccount
  } else {
    removeStorageItem(LOCAL_STORAGE_MAILS_ACTIVE_ACCOUNT_KEY)
  }

  return accounts.find(i => i[ITEM_KEYS.activeKey]) || accounts[0]
}

export function getSubMenuEmailsActiveValue(value, accounts) {
  return accounts.find(i => i[ITEM_KEYS.selectedKey].toString() === value)
}

export function subMenuEmailsFilterFolders(folders, emailClient) {
  if (emailClient) {
    return folders.filter(
      i => i[FOLDER_ITEM_KEYS.value] !== EmailSubMenuParam.Archive
    )
  }

  return folders.filter(
    i => i[FOLDER_ITEM_KEYS.value] !== EmailSubMenuParam.Trash
  )
}

export function getSubMenuEmailsActiveFolder(activeAccount) {
  if (isEmailCorporate(activeAccount)) {
    return ACCOUNTS_CORPORATE
  }

  if (isEmailShared(activeAccount)) {
    return ACCOUNTS_SHARED
  }

  return ACCOUNTS_PRIVATE
}

export function getSubMenuFolderAvailableAccounts(accounts, folder) {
  return getEmailAvailableAccounts(accounts[folder])
}

export function getSubMenuPrivateFolderAvailableAccounts(accounts) {
  return getSubMenuFolderAvailableAccounts(accounts, ACCOUNTS_PRIVATE)
}
